module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-Teddy-72dpi.015e0015.jpg";